module.exports = __webpack_public_path__ + "img/travel_thumbnail.fc87d227.jpg";